import { formatDate } from "../../utils/helpers";
import { Avatar } from "./Avatar";

import style from "./CommentHeader.module.css";

interface CommentHeaderProps {
  name: string;
  commentedAt: string;
  actions?: React.ReactNode;
}

export const CommentHeader = ({ name, commentedAt, actions }: CommentHeaderProps) => {
  return (
    <div className={style.header}>
      <Avatar title={name} />
      <div className={style.info}>
        <div className={style.name}>{name}</div>
        <div className={style.date}>{formatDate(commentedAt)}</div>
      </div>
      <div className={style.actions}>{actions}</div>
    </div>
  );
};
